import { render, staticRenderFns } from "./CohortManager.vue?vue&type=template&id=5a355718&scoped=true"
import script from "./CohortManager.vue?vue&type=script&lang=js"
export * from "./CohortManager.vue?vue&type=script&lang=js"
import style0 from "./CohortManager.vue?vue&type=style&index=0&id=5a355718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a355718",
  null
  
)

export default component.exports